<template>
    <div class="flex items-center rounded-full bg-white h-8 border border-gray-100">
        <div class="basis-1/6 flex items-center">
            <IonIcon
                :icon="icon"
                class="h-8 w-8 rounded-full"
                :style="iconStyle"
            />
        </div>
        <div class="grow flex items-center justify-center pointer-events-none">
            <div><em>{{ text }}</em></div>
        </div>
        <div
            v-if="buttonText"
            class="basis-2/6 flex items-center justify-center buttonText"
        >
            <button @click="$emit('click')"><strong>{{ buttonText }}</strong></button>
        </div>
    </div>
</template>


<script
    setup
    lang="ts"
>
import { IonIcon } from '@ionic/vue';
import { computed } from 'vue';

const props = defineProps({
    text: {
        type: String,
        required: true
    },
    buttonText: {
        type: String,
        required: false
    },
    icon: {
        type: String,
        required: true
    },
    iconColor: {
        type: String,
        required: false
    }
});

defineEmits(['click']);

const iconStyle = computed(() => {
    return props.iconColor ? { "color": props.iconColor } : {};
});

</script>


<style scoped>
.buttonText {
    color: var(--action-button-color, #59C4F6)
}
</style>